import styled from "@emotion/styled";
import { GrBox, GrProgressCircle } from "@jnpmedi/grebob";

export function ViewportCenterCircle() {
  return (
    <ViewportCenterCircleWrapper>
      <GrProgressCircle size={40} variant="indeterminate" />
    </ViewportCenterCircleWrapper>
  );
}

const ViewportCenterCircleWrapper = styled(GrBox)`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
